import Events from 'events'

const wsEvents = new Events.EventEmitter()

export default wsEvents
